import Hero from 'components/home/Hero';
import BrandStatement from 'components/home/BrandStatement';
import ProductHighlights from 'components/home/ProductHighlights';
import OrderSection from 'components/order/OrderSection';
import WhyMoraPreview from 'components/home/WhySingaraaPreview';
import HeritageSection from 'components/home/HeritageSection';
import PeanutBenefits from 'components/home/PeanutBenefits';
import PageMeta from 'components/layout/PageMeta';

export const metadata = {
  title: 'Mora | Premium Quality Supari & Wholesale Snacks',
  description: 'Mora brings Premium Quality Supari with a naturally crunchy taste, rooted in Indian snacking culture. Order directly or inquire for wholesale.',
};

export default function HomePage() {
  return (
    <main className="min-h-screen bg-Mora-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      <Hero />
      <BrandStatement />
      <ProductHighlights />
      <OrderSection 
        id="order-now"
        eyebrow="FRESH ROASTED SNACKS"
        title="Order Your Pack of Mora"
        subtitle="Crunchy, protein-rich Premium Quality Supari delivered fresh to your doorstep"
      />
      <PeanutBenefits />
      <WhyMoraPreview />
      <HeritageSection />
    </main>
  );
}
